import { VIDEO_NODE_EVENT } from '../enums';
/**
 * 对外发送展示/隐藏Loading事件
 */
var Loading = /** @class */ (function () {
    /**
     * 构造函数需要传递事件发送对象
     * @param evtEmiter 事件发送对象
     */
    function Loading(evtEmiter) {
        this.delayTimeoutId = 0;
        this.evtEmiter = evtEmiter;
    }
    /**
     * 发送展示loading事件
     * @param delayShowTimeMS 延迟展示Loading时间，单位毫秒，0为立即展示
     */
    Loading.prototype.show = function (delayShowTimeMS) {
        var _this = this;
        if (delayShowTimeMS === void 0) { delayShowTimeMS = 0; }
        if (!this.evtEmiter) {
            return;
        }
        this.clearDelay();
        if (delayShowTimeMS === 0) {
            this.evtEmiter.emit(VIDEO_NODE_EVENT.SET_LOADING, { show: true });
            return;
        }
        this.delayTimeoutId = window.setTimeout(function () {
            _this.evtEmiter.emit(VIDEO_NODE_EVENT.SET_LOADING, { show: true });
        }, delayShowTimeMS);
    };
    /**
     * 隐藏loading事件，如果有延迟展示也会清除
     */
    Loading.prototype.hide = function () {
        if (!this.evtEmiter) {
            return;
        }
        this.clearDelay();
        this.evtEmiter.emit(VIDEO_NODE_EVENT.SET_LOADING, { show: false });
    };
    /**
     * 清除延迟展示的loading，外部在destroy时可以调用
     */
    Loading.prototype.clearDelay = function () {
        if (this.delayTimeoutId > 0) {
            window.clearTimeout(this.delayTimeoutId);
            this.delayTimeoutId = 0;
        }
    };
    return Loading;
}());
export default Loading;
